<template>
  <div class="Button-group u-flex u-flex-spaceBetween">
    <div class="left-container">
      <slot name="left-aligned-buttons" />
    </div>
    <div class="right-container">
      <slot name="right-aligned-buttons" />
    </div>
  </div>
</template>
<script>
export default {
};
</script>
<style scoped lang="less">
.Button-group {
  padding: 20px 0;
}
</style>
